import React from "react";

import { signInWithRedirect } from "@aws-amplify/auth";
import { Authenticator, ThemeProvider, createTheme, useTheme, View, Image, Button, Flex, Divider, Text } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";

import arupLogo from "../assets/arup_red.svg";
import "./Theme";

interface IProps {
	children?: React.ReactNode;
	region: string;
	userPoolId: string;
	userPoolWebClientId: string;
	domain: string;
	scope?: string[];
	allowSignUp?: boolean;
	azureADProviderId: string;
	hideFormFields?: boolean;
}

const arupTheme = createTheme({
	name: "arup-theme",
	tokens: {
		components: {
			button: {
				primary: {
					backgroundColor: { value: "#e8303a" },
					color: { value: "#ffffff" },
					_hover: {
						backgroundColor: { value: "#cf1720" },
					},
					_focus: {
						backgroundColor: { value: "#cf1720" },
					},
					_active: {
						backgroundColor: { value: "#b60007" },
					},
				},
			},
		},
	},
});

const AuthenticationProvider: React.FC<IProps> = (props) => {
	Amplify.configure({
		Auth: {
			Cognito: {
				userPoolId: props.userPoolId,
				userPoolClientId: props.userPoolWebClientId,
				loginWith: {
					oauth: {
						domain: props.domain,
						scopes: props.scope || ["email", "profile", "openid"],
						redirectSignIn: [window.location.origin],
						redirectSignOut: [window.location.origin],
						responseType: "code",
					},
				},
			},
		},
	});

	const renderApp = () => <>{props.children}</>;
	const HideForm = React.lazy(() => import("./HideForm"));

	const components = {
		Header() {
			const { tokens } = useTheme();

			return (
				<View textAlign="center" padding={tokens.space.large}>
					<React.Suspense fallback={<></>}>{props.hideFormFields && <HideForm />}</React.Suspense>
					<Image alt="Arup logo" src={arupLogo} maxWidth="50%" />
				</View>
			);
		},
		SignIn: {
			Header() {
				return (
					<>
						{props.azureADProviderId && (
							<>
								<Flex
									padding="var(--amplify-space-xl) var(--amplify-space-xl) 0 var(--amplify-space-xl)"
									direction="column"
								>
									<Button
										width="100%"
										fontWeight="500"
										color="#e8303a"
										border="1px solid #e8303a"
										className="arup-signin-btn"
										onClick={() => {
											signInWithRedirect({
												provider: { custom: props.azureADProviderId },
											});
										}}
									>
										{props.hideFormFields ? "Sign in" : "Sign in with your Arup Account"}
									</Button>
									<Flex style={props.hideFormFields ? { visibility: "hidden" } : {}}>
										<Divider orientation="horizontal" size="small" alignSelf="center" />
										<Text>or</Text>
										<Divider orientation="horizontal" size="small" alignSelf="center" />
									</Flex>
								</Flex>
							</>
						)}
					</>
				);
			},
		},
	};

	return (
		<ThemeProvider theme={arupTheme}>
			<Authenticator variation="modal" components={components} hideSignUp={!props.allowSignUp}>
				{renderApp}
			</Authenticator>
		</ThemeProvider>
	);
};

export default AuthenticationProvider;
